
export interface CallCenterUsersState {
  callCenterUsers: CallCenterUserItem[];
  callCenterUserItem?: CallCenterUserItem;
}

export interface CallCenterUserItem {
  id?: number;
  name?: string;
  email?: string;
  partner?: string;
  status?: number;

  password?: string;
  confirm_password?: string;
  show_messages_text?: number;
  is_check_pass?: number;
  timezone_id?: number;
}

export class CallCenterUserItemImpl implements CallCenterUserItem {
  id?: number;
  name?: string;
  email?: string;
  partner?: string;
  status?: number;
  show_messages_text?: number;
  is_check_pass?: number;
  password?: string;
  confirm_password?: string;
  timezone_id?: number;

  constructor() {
    this.status = 0;
    this.show_messages_text = 1;
    this.is_check_pass = 0;
    this.timezone_id = 4;
  }
}

export class CallCenterUserFilter {
  id?: number;
  name?: string;
  email?: string;
  partner?: string;
  status?: number;
  role_id?: number;
  page_number: number =  1;
}
